import Button from "@rio-cloud/rio-uikit/Button"
import FormLabel from "@rio-cloud/rio-uikit/FormLabel"
import Select from "@rio-cloud/rio-uikit/Select"
import { useIntl } from "react-intl"
import * as React from "react"
import { useMemo } from "react"
import { CargoTypeFilter, TransportOrderStatusFilter } from "@/redux/transportorder.slice"

interface TransportOrderFilterPanelProps {
    cargoTypeFilter: CargoTypeFilter
    onCargoTypeFilterChange: (cargoTypeFilter: CargoTypeFilter) => void
    statusFilter: TransportOrderStatusFilter
    onStatusFilterChange: (statusFilter: TransportOrderStatusFilter) => void
    onClose: () => void
}

export const TransportOrderFilterPanel = (props: TransportOrderFilterPanelProps): React.ReactElement => {
    const {
        cargoTypeFilter,
        onCargoTypeFilterChange,
        statusFilter,
        onStatusFilterChange,
        onClose,
    } = props
    const intl = useIntl()

    const cargoTypeOptions = useMemo(() => [
        {
            id: CargoTypeFilter.ALL,
            label: intl.formatMessage({ id: "transportOrder.overview.toolbar.cargoTypeFilter.all" }),
        },
        {
            id: CargoTypeFilter.EMPTIES,
            label: intl.formatMessage({ id: "shipment.type.empties" }),
        },
        {
            id: CargoTypeFilter.MATERIAL,
            label: intl.formatMessage({ id: "shipment.type.materials" }),
        }
    ], [intl])
    const statusFilterOptions = useMemo(() => [
        {
            id: TransportOrderStatusFilter.ALL,
            label: intl.formatMessage({ id: "transportOrder.overview.toolbar.statusFilter.all" }),
        },
        {
            id: TransportOrderStatusFilter.CONFIRMED,
            label: intl.formatMessage({ id: "transportOrder.overview.toolbar.statusFilter.confirmed" }),
        },
        {
            id: TransportOrderStatusFilter.UNCONFIRMED,
            label: intl.formatMessage({ id: "transportOrder.overview.toolbar.statusFilter.unconfirmed" }),
        },
    ], [intl])

    const handleCargoTypeFilterChange = (option: { id: CargoTypeFilter } | undefined) => {
        onCargoTypeFilterChange(option?.id ?? CargoTypeFilter.ALL)
    }

    const handleStatusFilterChange = (option: { id: TransportOrderStatusFilter } | undefined) => {
        onStatusFilterChange(option?.id ?? TransportOrderStatusFilter.ALL)
    }

    return (
        <section
            id="transport-order-filter-panel"
            className="panel panel-default position-relative padding-20 margin-top-10"
            aria-label={intl.formatMessage({ id: "transportOrder.overview.toolbar.filter.label" })}
        >
            <div className="position-absolute top-10 right-10">
                <Button
                    iconName="icon-remove"
                    iconOnly
                    bsSize="xs"
                    bsStyle="muted"
                    variant="link"
                    aria-label={intl.formatMessage({ id: "application.close" })}
                    onClick={onClose}
                />
            </div>
            <div className="display-flex flex-wrap justify-content-center gap-20">
                <div className="min-width-250" data-testid="transport-order-cargo-type-filter">
                    <FormLabel htmlFor="transport-order-cargo-type-filter">
                        {intl.formatMessage({ id: "transportOrder.overview.toolbar.transportAndCargoTypeFilter.label" })}
                    </FormLabel>
                    <Select
                        id="transport-order-cargo-type-filter"
                        options={cargoTypeOptions}
                        value={[cargoTypeFilter]}
                        onChange={handleCargoTypeFilterChange}
                    />
                </div>
                <div className="min-width-250">
                    <FormLabel htmlFor="transport-order-status-filter">
                        {intl.formatMessage({ id: "transportOrder.overview.toolbar.statusFilter.label" })}
                    </FormLabel>
                    <Select
                        id="transport-order-status-filter"
                        options={statusFilterOptions}
                        value={[statusFilter]}
                        onChange={handleStatusFilterChange}
                    />
                </div>
            </div>
        </section>
    )
}
